import React, { FC } from "react";
import { Icon } from "@bookingcom/bui-react";
import { Color } from "@bookingcom/bui-react/components/Icon/Icon.types";
import { UIBrandedFareFeatureAvailability } from "@flights/types";
import styles from "./FareFeatureIcon.module.css";
import { mcn } from "utils/mergeClassnames";
import useAvailabilityIcon from "branded-fares/hooks/useAvailabilityIcon";

type Props = {
  availability: UIBrandedFareFeatureAvailability;
  icon: FC;
  isLarge?: boolean;
  inline?: boolean;
  color?: Color;
};

const FareFeatureIcon = ({ availability, icon, isLarge, inline, color }: Props) => {
  const availabilityIcon = useAvailabilityIcon(availability);
  const iconClassName = availabilityIcon ? styles.iconWithAvailability : "";

  return (
    <div className={styles.featureIconWrapper}>
      <Icon
        className={mcn(iconClassName, inline ? "" : styles.fixedWidth)}
        size={isLarge ? "large" : "medium"}
        svg={icon}
        color={color ?? "neutral"}
      />
      {availabilityIcon && (
        <Icon
          size="smallest"
          svg={availabilityIcon.icon}
          color={availabilityIcon.color}
          className={styles.availabilityIcon}
        />
      )}
    </div>
  );
};

export default FareFeatureIcon;
